import { Cloud, Flame } from 'lucide-react';

export type HubFilter =
  | 'all'
  | 'azure'
  | 'firebase'
  | 'production'
  | 'dev'
  | 'poc';

const FILTERS: { id: HubFilter; label: string; icon?: 'cloud' | 'flame' }[] = [
  { id: 'all', label: 'Toutes' },
  { id: 'azure', label: 'Azure', icon: 'cloud' },
  { id: 'firebase', label: 'Firebase', icon: 'flame' },
  { id: 'production', label: 'Production' },
  { id: 'dev', label: 'En dev' },
  { id: 'poc', label: 'PoC' },
];

export interface FilterBarProps {
  activeFilter: HubFilter;
  onChange: (f: HubFilter) => void;
}

export function FilterBar({ activeFilter, onChange }: FilterBarProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {FILTERS.map(({ id, label, icon }) => {
        const active = activeFilter === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
              active
                ? 'border-[#0f172a] bg-[#0f172a] text-white dark:border-slate-100 dark:bg-slate-100 dark:text-slate-900'
                : 'border-slate-200 bg-white text-slate-700 hover:border-[#e11d48] hover:text-[#e11d48] dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:border-[#e11d48]'
            }`}
          >
            {icon === 'cloud' && <Cloud className="h-3.5 w-3.5" />}
            {icon === 'flame' && <Flame className="h-3.5 w-3.5" />}
            {label}
          </button>
        );
      })}
    </div>
  );
}
